import React from "react";
import { MathOperatorChildrenType } from "../mathOperatorTypes";

const ButtonBox = ( {children} : MathOperatorChildrenType) => {
  return <div className='tw-w-[100%] tw-h-[100%] tw-grid tw-grid-cols-6 tw-grid-rows-4 tw-gap-3'>{children}</div>;
};

export default ButtonBox;